import { render, staticRenderFns } from "./Gro.vue?vue&type=template&id=39981b00&scoped=true&"
import script from "./Gro.vue?vue&type=script&lang=js&"
export * from "./Gro.vue?vue&type=script&lang=js&"
import style0 from "./Gro.vue?vue&type=style&index=0&id=39981b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39981b00",
  null
  
)

export default component.exports